import { Box } from "@mui/material";
import CircularProgressWithLabel from "@common/components/circularProgressWithLabel/CircularProgressWithLabel";
import { toPercentage } from "@common/utilities";
import RiskReportCard from "../RiskReportCard";
import RiskReportCardCount from "../RiskReportCardCount";
import { RiskReportCoverage } from "../RiskManagementReport.types";

interface AssessedCoverageCardProps {
    isLoading: boolean;
    coverage: RiskReportCoverage;
}

function AssessedCoverageCard({ isLoading, coverage }: AssessedCoverageCardProps) {
    return (
        <RiskReportCard
            isLoading={isLoading}
            background="purple"
            header={coverage.header}
            topRight={<CircularProgressWithLabel value={toPercentage(coverage.assessed, coverage.total)} variant="onDark" />}
        >
            <RiskReportCardCount count={coverage.assessed} label={coverage.label} marginTop={0} />
            {coverage.breakdown && <Box sx={(theme) => ({ fontSize: theme.typography.pxToRem(16), marginTop: 1, opacity: 0.85 })}>{coverage.breakdown}</Box>}
        </RiskReportCard>
    );
}

export default AssessedCoverageCard;
